import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import FinancialPaymentNewEditForm from './FinancialPaymentNewEditForm';
// ----------------------------------------------------------------------

export default function FinancialPaymentCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit ? `${translate('FinancialPayment.CreateFinancialPayment')}` : `${translate('FinancialPayment.UpdateFinancialPayment')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('FinancialPayment.CreateFinancialPayment')}`
              : `${translate('FinancialPayment.EditFinancialPayment')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('FinancialPayment.FinancialPaymentList')}`,
              href: PATH_DASHBOARD.FinancialPayment.list,
            },
            {
              name: !isEdit
                ? `${translate('FinancialPayment.CreateFinancialPayment')}`
                : `${translate('FinancialPayment.UpdateFinancialPayment')}`,
            },
          ]}
        />
        <FinancialPaymentNewEditForm />
      </Container>
    </Page>
  );
}
